<template>
    <ion-toolbar class="background-purple-background purple-light-color" style="--border-width: 0;">
        <ion-buttons slot="start">
            <ion-button
                @click="$emit('back')"
                class="purple-light-color"
            >
                <ion-icon :icon="chevronBack"/>
                {{ $t('button.back') }}
            </ion-button>
        </ion-buttons>

        <ion-title mode="ios">{{ title ?? $t('titleRoute.filter') }}</ion-title>

        <ion-buttons slot="end" style="width: calc(44px + 3.4rem)"></ion-buttons>
    </ion-toolbar>
</template>

<script setup lang="ts">
import { IonToolbar, IonButtons, IonButton, IonTitle, IonIcon } from "@ionic/vue";
import { chevronBack } from "ionicons/icons";

defineProps<{ title?: string }>()
defineEmits<{ (e: 'back'): void }>()
</script>
